export default (that) => [
  {
    field: 'seq',
    width: 40,
    align: 'center',
    type: 'seq',
    fixed: 'left',
  },
  {
    field: 'radio',
    width: 40,
    align: 'center',
    fixed: 'left',
    type: 'radio',
  },
  {
    title: that.$l('form_label_specName') || '产品规格',
    field: 'specName',
    minWidth: 170,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_custName') || '客户',
    field: 'custName',
    minWidth: 180,
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_custOrderNo') || '客户订单编号',
    field: 'custOrderNo',
    minWidth: 180,
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_factoryOrderNo') || '工厂订单编号',
    field: 'factoryOrderNo',
    minWidth: 180,
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_orderTechPricingNo') || '工价单编号',
    field: 'orderTechPricingNo',
    minWidth: 170,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_productName') || '产品名称',
    field: 'productName',
    minWidth: 200,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_categoryFullName') || '产品分类',
    field: 'categoryFullName',
    minWidth: 200,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_authorByName') || '编制人员',
    field: 'authorByName',
    minWidth: 200,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_displayModify') || '修改人',
    field: 'displayModify',
    width: 170,
    align: 'center',
    showHeaderOverflow: true,
    slots: { default: 'displayModify' },
  }
]
